import React, { useState, useEffect } from 'react';
import { Grid, Box, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { useForm, useFieldArray } from 'react-hook-form';
import _ from 'lodash';
import { convertToDateIgnoringTime } from '../../../../../utils/helpers';
import { getBoardCertifications } from '../../../../../services/Credentialing';
import { COLORS } from '../../../../../utils/Application_Constants';
import ViewMoreButton from './ViewMoreButton';

const styles = makeStyles((theme) => ({
    header: {
        // color: COLORS.BLACK_MARLIN,
        // [theme.breakpoints.down('sm')]: {
        //     padding: '15px 0 0 15px',
        // },
        // textAlign: 'left',
        // paddingLeft: '32px',
        // paddingTop: '16px',
        // fontSize: '22px',
        // fontWeight: '700',
    },
    tableHeader: {
        borderBottom: `1px solid ${COLORS.LT_SLATE10}`,
        marginBottom: '1rem',
    },
    root: {
        padding: '20px 0',
        minHeight: '800px',
        [theme.breakpoints.down('md')]: {
            paddingTop: '60px',
            marginTop: '25px',
        },
        maxWidth: '100%',
        // backgroundColor: COLORS.BLACK_HAZE,
    },
    helpPanelContainerRoot: {
        padding: '15px',
        display: 'flex',
        flexWrap: 'wrap',
        [theme.breakpoints.down('md')]: {
            padding: '0px',
        },
    },
    linkHeader: {
        color: COLORS.DENIM,
        textDecoration: 'none',
        display: 'flex',
        fontWeight: '700',
        fontSize: '22px',
        margin: 0,
        textAlign: 'left',
    },
    sectionStyle: {
        color: COLORS.DENIM,
        fontWeight: '700',
        display: 'flex',
    },
    info: {
        color: COLORS.RAVEN,
        fontWeight: '700',
        fontSize: '16px',
        textAlign: 'left',
    },
    columnInfoLeft: {
        color: COLORS.RAVEN,
        fontWeight: '500',
        fontSize: '16px',
        textAlign: 'left',
        margin: '20px 0 10px 0',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    columnInfoRight: {
        color: COLORS.RAVEN,
        fontWeight: '500',
        fontSize: '16px',
        textAlign: 'right',
        margin: '20px 0 10px 0',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    lifeTime: {
        marginRight: '29px',
    },
    columnHeaderLeft: {
        color: COLORS.BLACK_MARLIN,
        fontWeight: '900',
        fontSize: '16px',
        textAlign: 'left',
        marginTop: '20px',
        borderBottom: `1px solid ${COLORS.WHITE_LILAC}`,
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    columnHeaderRight: {
        color: COLORS.BLACK_MARLIN,
        fontWeight: '900',
        fontSize: '16px',
        textAlign: 'left',
        marginTop: '20px',
        borderBottom: `1px solid ${COLORS.WHITE_LILAC}`,
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    noMaxWidth: {
        maxWidth: 'none',
    },
    topTileRoot: {
        marginTop: '30px',
        height: '85%',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    expirationDate: {
        textAlign: 'right',
    },
    expirationDateHeader: {
        fontWeight: '900',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        textAlign: 'right',
    },
    iconAlign: {
        paddingLeft: '110px',
        paddingTop: '0px',
    },
    dateInfoGrid: {
        display: 'grid',
        width: '70px',
        gridTemplateColumns: 'repeat(auto-fit, minmax(30px, 1fr))',
        [theme.breakpoints.down('md')]: {
            width: '50px',
            gridTemplateColumns: 'repeat(auto-fit, minmax(25px, 1fr))',
        },
    },

    dateItemColumn: {
        textAlign: 'center',
    },
    iconIndicator: {
        textAlign: 'left',
    },
}));

function BoardCertsCard({
    t,
    UserContext,
    setCredAppError,
    isLoaded,
    setIsLoaded,
    renderIndicatorColor,
    activePath,
}) {
    const classes = styles();
    const [viewMore, setViewMore] = useState(false);

    const toggleViewMore = () => {
        setViewMore(!viewMore);
    };

    const { control, reset } = useForm({
        mode: 'all',
        defaultValues: {
            id: null,
            specialty: '',
            lifetimeCertified: null,
            expirationDate: null,
        },
    });

    const { fields, append } = useFieldArray({
        control,
        name: 'providerSpecialties',
        keyName: 'internalId',
    });

    useEffect(() => {
        (async function fetchData() {
            const { externalId } = UserContext;

            await getBoardCertifications(externalId)
                .then((response) => {
                    console.log('boardCerts response ', response);
                    const { providerSpecialties = [] } = response;

                    if (providerSpecialties.length === 0) {
                        append({
                            id: null,
                            specialty: '',
                            lifetimeCertified: false,
                            expirationDate: null,
                        });
                        response.providerSpecialties.push({
                            id: null,
                            specialty: '',
                            lifetimeCertified: false,
                            expirationDate: null,
                        });
                    } else {
                        response.providerSpecialties.map((item) => {
                            if (item.specialty === null) {
                                item.specialty = '';
                            }

                            return item;
                        });
                    }
                    reset(response);
                    setIsLoaded(true);
                })
                .catch((e) => {
                    setCredAppError(e);
                });
        })();
    }, []);

    const filterSpecialties = (providerSpecialtiesFields) => {
        const filterOldProviderSpecialties = providerSpecialtiesFields.filter((item) => {
            const today = moment(moment());
            const expirationDate = moment(item.expirationDate);

            if (today.diff(expirationDate, 'years', false) < 5) {
                return item;
            }
        });

        const lifetimeCertifiedSpecialties = providerSpecialtiesFields.filter(
            (item) => item.lifetimeCertified === true
        );

        const dateSortedProviderSpecialties = _.orderBy(
            filterOldProviderSpecialties,
            [(obj) => new Date(obj.expirationDate)],
            ['asc']
        );

        const finalSpecialtiesList = dateSortedProviderSpecialties.concat(
            lifetimeCertifiedSpecialties
        );

        return finalSpecialtiesList;
    };

    const renderSpecialties = () => {
        let finalSpecialtiesList = filterSpecialties(fields);

        if (!viewMore) {
            finalSpecialtiesList = finalSpecialtiesList.slice(0, 4);
        }

        if (!isLoaded) {
            return (
                <div className={classes.progress}>
                    <CircularProgress />
                </div>
            );
        }
        return (
            <Grid container>
                {finalSpecialtiesList.map((item) => (
                    <>
                        <Grid item xs={8} md={8}>
                            <p>{activePath === 'AP' ? item.certificationType : item.specialty}</p>
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <p>
                                {renderIndicatorColor(item.expirationDate)}
                                {item.lifetimeCertified ? (
                                    <span className={classes.lifeTime}>Lifetime</span>
                                ) : (
                                    <span>
                                        {convertToDateIgnoringTime(item.expirationDate).format(
                                            'MM/DD/YYYY'
                                        )}
                                    </span>
                                )}
                            </p>

                            {/* <div className={classes.dateInfoGrid}>
                                    {renderIndicatorColor(item.expirationDate)}
                                    {item.lifetimeCertified ? <span className={classes.lifeTime}>Lifetime</span>
                                    :<div className={classes.dateItemColumn}>{convertToDateIgnoringTime(item.expirationDate).format('MM/DD/YYYY')}</div>
                                    }
                                </div> */}
                        </Grid>
                    </>
                ))}
            </Grid>
        );
    };

    const renderBoardCerts = () => {
        const finalSpecialtiesList = filterSpecialties(fields);

        return (
            <Box mb={4}>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>{t('credentials:CRED_OVERVIEW.BOARD_CERTS_TITLE')}</h3>
                        <p>{t('credentials:CRED_OVERVIEW.BOARD_CERTS_INFO')}</p>
                    </Grid>

                    <Grid container direction="row" className={classes.tableHeader}>
                        <Grid item xs={8} md={8}>
                            {activePath === 'AP' ? (
                                <h6 className="cr-mb-0">
                                    {t('credentials:CRED_OVERVIEW.CERT_TYPE')}
                                </h6>
                            ) : (
                                <h6 className="cr-mb-0">
                                    {t('credentials:CRED_OVERVIEW.SPECIALTY')}
                                </h6>
                            )}
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <h6 className="cr-mb-0">
                                {t('credentials:CRED_OVERVIEW.EXPIRATION_DATE')}
                            </h6>
                        </Grid>
                    </Grid>

                    <Grid container direction="row">
                        <Grid item xs={12} md={12}>
                            {renderSpecialties()}
                        </Grid>
                        {finalSpecialtiesList.length > 4 ? (
                            <ViewMoreButton
                                t={t}
                                viewMore={viewMore}
                                toggleViewMore={toggleViewMore}
                            />
                        ) : null}
                    </Grid>
                </Grid>
            </Box>
        );
    };

    return <>{renderBoardCerts()}</>;
}

export default BoardCertsCard;
